// English
exports['en'] = {
  current: 'current',
  time: 'time',
  deleteSelected: 'Delete selected',
};
exports['en_EN'] = exports['en'];
exports['en_US'] = exports['en'];

// Italiano
require('moment/locale/it');
exports['it'] = {
  current: 'attuale',
  time: 'tempo',
  deleteSelected: 'Cancella la selezione',
};
exports['it_IT'] = exports['it'];
exports['it_CH'] = exports['it'];

// Dutch
require('moment/locale/nl');
exports['nl'] = {
  current: 'huidige',
  time: 'tijd',
  deleteSelected: 'Selectie verwijderen'
};
exports['nl_NL'] = exports['nl'];
exports['nl_BE'] = exports['nl'];

// German
require('moment/locale/de');
exports['de'] = {
  current: 'Aktuelle',
  time: 'Zeit',
  deleteSelected: 'L\u00f6sche Auswahl',
};
exports['de_DE'] = exports['de'];

// French
require('moment/locale/fr');
exports['fr'] = {
  current: 'actuel',
  time: 'heure',
  deleteSelected: 'Effacer la selection',
};
exports['fr_FR'] = exports['fr'];
exports['fr_CA'] = exports['fr'];
exports['fr_BE'] = exports['fr'];

// Espanol
require('moment/locale/es');
exports['es'] = {
  current: 'corriente',
  time: 'hora',
  deleteSelected: 'Eliminar selecci\u00f3n',
};
exports['es_ES'] = exports['es'];

// Ukrainian
require('moment/locale/uk');
exports['uk'] = {
  current: 'поточний',
  time: 'час',
  deleteSelected: 'Видалити обране',
};
exports['uk_UA'] = exports['uk'];

// Russian
require('moment/locale/ru');
exports['ru'] = {
  current: 'текущее',
  time: 'время',
  deleteSelected: 'Удалить выбранное',
};
exports['ru_RU'] = exports['ru'];

// Japanese
require('moment/locale/ja');
exports['ja'] = {
  current: '現在',
  time: '時刻',
  deleteSelected: '選択されたものを削除',
};
exports['ja_JP'] = exports['ja'];
